module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/projektyWeb/McComp_Flota/Front/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main